import React, { forwardRef } from 'react';
import NextRouterLink from 'next/link';

import formatURLS from '../../utils/formatURLS.v4';

interface LinkProps extends Record<string, any> {
  children?: React.ReactNode;
  to?: string | Record<string, any>;
  href?: string | Record<string, any>;
}

//
// We're forwarding refs (if they're provided) here because certain Chakra components
// (Popover, Menu) require refs to calculate specific UI states (e.g. positioning, visibility)
// that don't interact well with Next's link component
const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, to = '', href = '', locale, ...rest }, ref) => {
    const { href: formattedHref, as: formattedAs } = formatURLS(href || to);

    return (
      <NextRouterLink
        ref={ref}
        href={formattedHref}
        as={formattedAs}
        locale={locale}
        prefetch={false}
        {...rest}
      >
        {children}
      </NextRouterLink>
    );
  },
);

export default Link;
